// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__2Usk4","label":"Row_label__3Ixdg","content":"Row_content__28Pix"};